<form class="division-filter">
    <nb-select (selectedChange)="divisionChange($event)" [(ngModel)]="selectedValue" class="select-division" id="division_id" name="division_id">
        @for (division of divisions; track division.division_id) {
            <nb-option [value]="division.division_id">{{division.name}}</nb-option>
        }
    </nb-select>
</form>
